import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const InputField = ({ 
  label, 
  value, 
  onChange, 
  placeholder, 
  icon, 
  type = 'text',
  error 
}) => {
  const formatValue = (inputValue, inputType) => {
    if (!inputValue) return '';
    
    switch (inputType) {
      case 'currency':
        return inputValue.replace(/[^0-9.]/g, '');
      case 'percentage':
        return inputValue.replace(/[^0-9.]/g, '');
      case 'number':
        return inputValue.replace(/[^0-9]/g, '');
      default:
        return inputValue;
    }
  };

  const handleChange = (e) => {
    const formattedValue = formatValue(e.target.value, type);
    onChange(formattedValue);
  };

  const getDisplayValue = () => {
    if (!value) return '';
    
    switch (type) {
      case 'currency':
        return new Intl.NumberFormat('en-US').format(value);
      default:
        return value;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-2"
    >
      <label className="block text-sm font-semibold text-gray-700">
        {label}
      </label>
      
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <SafeIcon 
            icon={icon} 
            className={`text-lg ${error ? 'text-red-400' : 'text-gray-400'}`} 
          />
        </div>
        
        <input
          type="text"
          value={getDisplayValue()}
          onChange={handleChange}
          placeholder={placeholder}
          className={`w-full pl-12 pr-4 py-3 border-2 rounded-xl transition-all duration-300 focus:outline-none ${
            error 
              ? 'border-red-300 focus:border-red-500 bg-red-50' 
              : 'border-gray-200 focus:border-blue-500 bg-white'
          }`}
        />
        
        {type === 'percentage' && value && (
          <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
            <span className="text-gray-400">%</span>
          </div>
        )}
      </div>
      
      {error && (
        <motion.p
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-sm text-red-600 font-medium"
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};

export default InputField;